<div class="gt-routes-list-containerss" style="position: relative">
    <div class="container">
        <div class="upperToolbar">
            <dx-select-box class="modul-select-box" [dataSource]="componentTypeList" valueExpr="id" displayExpr="name"
                [(value)]="selectedComponentTypeId" (onSelectionChanged)="onComponentSelect($event)"
                i18n-placeholder="@@pleaseSelect" placeholder="Please Select" [searchEnabled]="true">
            </dx-select-box>

            <div class="button-container-upper">
                <app-gpd-button type="danger" icon="delete" (onClick)="showDeleteConfirmationPopup = true" text="Delete" i18n-text="@@Delete" [disabled]="!selectedComponentTypeId" [disabled]="!enableDeleteButton"></app-gpd-button>
                <app-gpd-button type="primary" text="Add" i18n-text="@@add" (onClick)="onAddClick()" ></app-gpd-button>
            </div>
        </div>
        <div class="tab">
            <div class="headings">
                <span i18n="@@general" style="font-weight: bold; font-size: 20px;">General</span>
            </div>
            <div style="margin-bottom: 20px;">
                <span class="tab-messages" i18n="@@generalMessage">Name the component and specify where it can be
                    used.</span>
            </div>
            <div *ngIf="showGeneralForm">
                <div class="general-row">
                    <label class="required" for="dataTypeInput">Name</label>
                    <dx-text-box id="dataTypeInput" [(value)]="dataTypeName" [disabled]="nameBoxDisabled"></dx-text-box>
                    <span *ngIf="inValidEntryAddComponent" class="dx-icon dx-icon-errorcircle"></span>

                </div>

                <div class="general-row">
                    <label class="required" i18n="@@allowedIn" for="allowedInSelect">Allowed In</label>
                    <dx-select-box id="allowedInSelect" placeholder="Bitte auswählen" [dataSource]="allowedInList"
                        valueExpr="id" displayExpr="name" [(value)]="selectedAllowedInId"
                        (onValueChanged)="onAllowedInChanged($event)" [disabled]="!!selectedComponentTypeId">
                    </dx-select-box>
                    <span *ngIf="showAllowedInError" class="dx-icon dx-icon-errorcircle"
                        title="allowed in is required"></span>
                </div>
                <div class="lt-container" style="margin-right: 10px; display: flex; justify-content: flex-end;">
                    <app-gpd-button i18n-text="@@cancel" text="cancel" icon="cancel" type="secondary" (onClick)="cancelEditOrCreate()"  [visible]="cancelButtonVisible"></app-gpd-button>
                    <app-gpd-button i18n-text="@@save" text="Save" icon="check" type="primary" (onClick)="saveTechComponentType()" [visible]="!hideSaveButton"></app-gpd-button>
                    <app-gpd-button type="primary" icon="edit" i18n-text="@@edit" text="Edit" (onClick)="editComp()" [visible]="hideSaveButton"></app-gpd-button>
                </div>
            </div>

        </div>
        <div class="spacer"></div>
        <!-- data type config -->
        <div class="tab">
            <div class="upperToolbar">
                <div class="headings">
                    <span i18n="@@data" style="font-weight: bold; font-size: 20px;">Data</span>
                </div>
                <app-gpd-button i18n-text="@@add" text="Add" icon="add" type="primary" (onClick)="openDataTypeForm()"
                    [disabled]="!enableAddData" style="margin-right: 20px;"></app-gpd-button>
            </div>
            <span class="tab-messages" i18n="@@defineComponentData">Define the relevant data for the component.</span>

            <dx-data-grid #datagrid class="gpd-datagrid" [visible]="showDataDataGrid" [showBorders]="true"
                [dataSource]="filteredDataFieldTypes" [noDataText]="noDataText">
                <dxo-header-filter visible="true"></dxo-header-filter>
                <dxi-column dataField="name" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="type" i18n-caption="@@type" caption="Type"
                    allowHeaderFiltering="true"></dxi-column>
                <dxi-column dataField="required" i18n-caption="@@required" caption="Required"
                    allowHeaderFiltering="true"></dxi-column>
                <dxi-column cellTemplate="cellTemplate" width="auto">
                    <div *dxTemplate="let data of 'cellTemplate'">
                        <div class="gpd-table-actions"><app-svg-icon *ngIf="!data.data.isSystemField" icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="editRow(data)"></app-svg-icon></div>
                    </div>
                </dxi-column>
                <dxi-column cellTemplate="deleteCellTemplate" width="auto">
                    <div *dxTemplate="let data of 'deleteCellTemplate'">
                        <div class="gpd-table-actions"><app-svg-icon *ngIf="!data.data.isSystemField" icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" (click)="datafieldDeleteCheck(data)"></app-svg-icon></div>
                    </div>
                </dxi-column>
            </dx-data-grid>

            <div class="dataForm" *ngIf="showDataTypeForm">
                <div class="general-row">
                    <label for="dataNameInput" class="required">Name</label>
                    <dx-text-box id="dataNameInput" [(value)]="dataName"></dx-text-box>
                    <span *ngIf="showDataNameError" class="dx-icon dx-icon-errorcircle"></span>
                </div>

                <div class="general-row">
                    <label for="typeSelect" class="required" i18n="@@type">Type</label>
                    <dx-select-box id="typeSelect" i18n-placeholder="@@pleaseSelect" placeholder="Please Select"
                        [dataSource]="dataTypeOptions" displayExpr="name" valueExpr="id" [(value)]="selectedDataTypeId"
                        (onSelectionChanged)="onDataTypeSelection($event)">
                    </dx-select-box>
                    <span *ngIf="showDataTypeError" class="dx-icon dx-icon-errorcircle"></span>

                </div>
                <div *ngIf="showDropDown" style="margin-right: 20px;">
                    <span i18n="@@dropdownOptions"
                        style="display: flex; justify-content: center; margin: 0 auto 10px auto;"><b>Dropdown
                            Options</b></span>
                    <div class="options-block">
                        <div class="general-row" *ngFor="let option of optionFields; let i = index">
                            <label for="optionInput" class="required">Option {{i + 1}}</label>
                            <dx-text-box id="optionInput" [(value)]="optionFields[i]" placeholder="Enter options"
                                i18n-placeholder="@@enterOptions" style="margin-top: 10px;"></dx-text-box>
                            <span *ngIf="blankOptionIndex === i" class="dx-icon dx-icon-errorcircle"
                                title="Option can't be blank" i18n-title="@@optionCannotBeBlank"></span>
                            <app-gpd-button icon="delete" type="text" (onClick)="onDeleteOption(i)" iconColor="red"></app-gpd-button>
                        </div>
                        <app-gpd-button
                          type="text"
                          icon="add"
                          i18n-text="@@addFurtherOptions"
                          text="Add Further Options"
                          (onClick)="onAddOption()"
                        ></app-gpd-button>
                    </div>
                </div>

                <div class="general-row">
                    <label for="showInTableInput" i18n="@@showInTable">Show in Table</label>
                    <dx-check-box id="showInTableInput" [(value)]="showInTable"></dx-check-box>
                </div>
                <div class="general-row">
                    <label for="mandatoryCheckbox" i18n="@@mandatoryField">Mandatory Field</label>
                    <dx-check-box id="mandatoryCheckbox" [(value)]="isMandatory"></dx-check-box>
                </div>

                <div class="lt-container" style="margin-right: 20px;">
                    <div class="lowerToolbar">
                        <app-gpd-button
                          type="secondary"
                          icon="cancel"
                          i18n-text="@@cancel"
                          text="Cancel"
                          (onClick)="closeAddDataPopup()"
                        ></app-gpd-button>
                        <app-gpd-button
                          icon="tick"
                          i18n-text="@@confirm"
                          text="Confirm"
                          (onClick)="saveTechComponentTypeData($event)"
                        ></app-gpd-button>
                    </div>
                </div>
            </div>

        </div>
        <!-- end -->


        <div class="spacer"></div>
        <!-- documents tab -->
        <div class="tab">
            <div class="upperToolbar">
                <div class="headings">
                    <span i18n="@@documents" style="font-weight: bold; font-size: 20px;">Documents</span>
                </div>
                <app-gpd-button
                  icon="add"
                  i18n-text="@@add"
                  text="Add"
                  [disabled]="!enableAddDocument"
                  (onClick)="openDocumentForm()"
                  style="margin-right: 20px"
                ></app-gpd-button>
            </div>
            <span class="tab-messages" i18n="@@specifyDocName">Define the relevant documents for the component.</span>
            <dx-data-grid #docDatagrid class="gpd-datagrid" [visible]="showDocumentsDataGrid"
                [dataSource]="filteredDocumentTypes" alignedColumns="left" [noDataText]="noDataText">
                <dxo-header-filter visible="true"></dxo-header-filter>
                <dxi-column dataField="name" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="required" i18n-caption="@@required" caption="Required"
                    allowHeaderFiltering="true"></dxi-column>
                <dxi-column cellTemplate="cellTemplate" width="auto">
                    <div *dxTemplate="let data of 'cellTemplate'">
                        <div class="gpd-table-actions"><app-svg-icon *ngIf="!data.data.isSystemDocument" icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="editDocRow(data)"></app-svg-icon></div>
                    </div>
                </dxi-column>
                <dxi-column cellTemplate="deleteCellTemplate" width="auto">
                    <div *dxTemplate="let data of 'deleteCellTemplate'">
                        <div class="gpd-table-actions"><app-svg-icon *ngIf="!data.data.isSystemDocument" icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" (click)="deleteDocumentTypeCheck(data)"></app-svg-icon></div>
                    </div>
                </dxi-column>
            </dx-data-grid>
            <div class="documentsForm" *ngIf="addDocumentForm">
                <div class="general-row">
                    <label for="docNameInput" class="required">Name</label>
                    <dx-text-box id="docNameInput" [(value)]="docName"></dx-text-box>
                    <span *ngIf="showDocNameError" class="dx-icon dx-icon-errorcircle"></span>
                </div>
                <div class="general-row">
                    <label for="isDocMandatoryInput" i18n="@@mandatoryField">Mandatory Field</label>
                    <dx-check-box id="isDocMandatoryInput" [(value)]="docMandatory"></dx-check-box>
                </div>
                <div class="lt-container" style="margin-right: 20px;">
                    <div class="lowerToolbar">
                        <app-gpd-button type="secondary" i18n-text="@@cancel" text="Cancel" icon="close"
                            (onClick)="closeDocumentForm()"></app-gpd-button>
                        <app-gpd-button type="primary" i18n-text="@@confirm" text="Confirm" icon="check"
                            (onClick)="saveDocument()"></app-gpd-button>
                    </div>
                </div>
            </div>

        </div>


        <!-- end -->
    </div>


</div>


<div *ngIf="isAddPopupVisible" class="gpd-overlay">

    <label for="dataTypeNameInput2" style="font-weight: bold;" i18n="@@newComponentTypeMessage">
        What should the component be named?
    </label>
    <div style="display: flex; flex-direction: row; margin-top: 20px;">
        <dx-text-box id="dataTypeNameInput2" [(value)]="dataTypeName" style="width: 450px;"></dx-text-box>
        <span *ngIf="inValidEntryAddComponent" class="dx-icon dx-icon-errorcircle" title="Name can't be blank"
            i18n-title="@@nameCannotBeBlank" style="margin-top: 10px;"></span>
    </div>
    <div class="gpd-overlay-footer-right" style="margin-top: 20px;">
        <app-gpd-button type="secondary" i18n-text="@@cancel" text="Cancel" icon="close" (onClick)="closeAddPopup()"></app-gpd-button>
        <app-gpd-button type="primary" i18n-text="@@confirm" text="Confirm" icon="check" (onClick)="confirmAddComponent()"></app-gpd-button>
    </div>
</div>


<div *ngIf="showDeleteRestrictionPopup" class="gpd-overlay-center">
    <div>
        <span id="warning-icon" class="dx-icon-warning"></span>
    </div>
    <span style="color: black;  margin-bottom: 18px; text-align: center;">
        <br>{{errMsg}}
    </span>
    <app-gpd-button icon="check" text="Verstanden" type="primary" (onClick)="closeRestrictedPopup()"></app-gpd-button>
</div>

<div *ngIf="showDeleteConfirmationPopup" class="gpd-overlay">
    <div>
        <span [innerHTML]="deleteConfirmationMessage"></span>
    </div>
    <div style="margin-top: 20px;"></div>
    <div class="gpd-overlay-footer-right">
        <app-gpd-button type="secondary" i18n-text="@@cancel" text="Cancel" icon="close"
            (onClick)="showDeleteConfirmationPopup = false"></app-gpd-button>
        <app-gpd-button type="primary" i18n-text="@@confirm" text="Confirm" icon="check"
            (onClick)="deleteTechComponentType()"></app-gpd-button>
    </div>
</div>


<div *ngIf="showErrMsg" class="gpd-overlay-center">
    {{errMsg}}
    <div style="margin-bottom: 20px;"></div>
    <app-gpd-button icon="check" text="Understood" i18n-text="@@understood"
        style="background: var(--color-primary); color: white; font-weight: bold; border-radius: 8px;  margin-top: 12px;"
        (onClick)="showErrMsg = false"> </app-gpd-button>
</div>


<div *ngIf="datafieldHasComponents || documentHasComponents" class="gpd-overlay">
    <div class="gpd-popup">
        <div class="gpd-container">
            <span>{{errMsg}}</span>
        </div>
        <div class="gpd-overlay-footer-left">
            <app-gpd-button i18n-text="@@Cancel" text="Cancel" (onClick)="cancelDeleteProcess()"
                type="secondary"></app-gpd-button>
            <app-gpd-button *ngIf="datafieldHasComponents" type="primary" i18n-text="@@confirm" text="Confirm"
                (onClick)="deleteDataTypeField()"></app-gpd-button>
                <app-gpd-button *ngIf="documentHasComponents" type="primary" i18n-text="@@confirm" text="Confirm"
                (onClick)="deleteDocument()"></app-gpd-button>
        </div>
    </div>
</div>